<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
    :key="$i18n.locale + 'counter'"
  >
    <template>
      <v-card flat>
        <v-card-title class="justify-end">
          <div class="rowinfo">
            <v-btn
              class="rounded-lg"
              color="red"
              outlined
              @click="deleteCounter"
            >
              <v-icon left>mdi-delete</v-icon>
              {{ $t("delete") }}
            </v-btn>
            <help-info
              :element-name="`${serviceName}-${componentName}-deleteCounter`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('delete')"
            />
          </div>
        </v-card-title>
        <div class="rowinfo">
          <v-text-field
            v-model="computedValue.title"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            :label="$t('title')"
            outlined
          />
          <help-info
            :element-name="`${serviceName}-${componentName}-computedValue-title`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('title')"
          />
        </div>
        <div class="rowinfo">
          <v-textarea
            v-model="computedValue.description"
            clear-icon="mdi-close-circle-outline"
            clearable
            dense
            :label="$t('description')"
            outlined
            rows="3"
          />
          <help-info
            :element-name="`${serviceName}-${componentName}-computedValue-description`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('description')"
          />
        </div>
        <div class="rowinfo">
          <custom-date-picker
            v-model="computedValue.until"
            append-icon="mdi-clock"
            dense
            outlined
            type="datetime"
            format="datetime"
            :key="$i18n.locale"
          />
          <help-info
            :element-name="`${serviceName}-${componentName}-computedValue-until`"
            :service-name="serviceName"
            :help-data="helpData"
            class="buttoninfo"
            :label="$t('selectdate')"
          />
        </div>
      </v-card>
    </template>
  </help-info-wrapper>
</template>

<script>
import CustomDatePicker from "@/view/content/custom-date-picker";
import moment from "moment-jalaali";

export default {
  name: "Counter",
  components: { CustomDatePicker },
  props: {
    value: Object,
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "counter",
      counter: {
        title: "",
        description: "",
        until: moment().format("YYYY-MM-DD HH:mm:ss"),
        type: "countdown_2",
      },
    };
  },
  computed: {
    computedValue: {
      get() {
        return this.value || this.counter;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    "$i18n.locale": {
      handler() {
        this.$forceUpdate();
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    deleteCounter() {
      this.computedValue = {
        title: "",
        description: "",
        until: moment().format("YYYY-MM-DD HH:mm:ss"),
        type: "countdown_2",
      };
    },
  },
};
</script>

<style scoped></style>
